﻿class Validation {
    constructor() {
        this.props = {
            forms: document.querySelectorAll('form'),
            checkoutForms: document.querySelectorAll('.checkout__form'),
            inputs: document.querySelectorAll('.js-validation')
        };
        if (this.props.inputs && this.props.forms) {
            this.bind();
        }
        if (this.props.checkoutForms) {
            this.bindCheckoutForms();
        }
    }
    bindCheckoutForms() {
        const {
            checkoutForms
        } = this.props;
        if (checkoutForms)
            Array.prototype.forEach.call(checkoutForms, (form) => {
                if (form) {
                    const nextStepButton = form.querySelector('.checkout-nextstep');
                    if (nextStepButton) {
                        nextStepButton.addEventListener('click', (buttonEvent) => {
                     
                            this.submit(buttonEvent, form);
                        })
                    }
                }
            })
    }
    bind() {
        const {
            inputs,
            forms
        } = this.props;
        Array.prototype.forEach.call(forms, (form) => {
            form.addEventListener('submit', (e) => this.submit(null, form));
        });

        inputs.forEach(input => {
          input.addEventListener('change', event => {
            const t = event.target;
            if (t.id === "ContractSSN") {
              if (t.value.length != 10) {
                this.setMessage(event);
              }
            }
          })
        });
        // inputs.forEach(input => {
        //   input.addEventListener("invalid", (event) => {
        //     const message = event.target.getAttribute('validationmessage')
        //     event.target.setCustomValidity(message)
        //   })
        //   // input.oninvalid = (event) => {

        //   // }
        // })
    }
    setMessage(event) {
        event.preventDefault();
        const message = event.target.getAttribute('validationmessage');
        event.target.setCustomValidity(message);
    }
    renderMessage(el, message, type, name) {
        if (!document.querySelector(`.${name}`)) {
            el.insertAdjacentHTML('afterend', '<div class="alert ' + type + ' ' + name + '">' + message + '</div>');
        }
    }
    submit(buttonEvent, form) {

        if (form) {
            const inputs = form.querySelectorAll('.js-validation');
            if (inputs)
                Array.prototype.forEach.call(inputs, (input) => {

                    input.oninput = event => {
                        input.classList.remove('validation--success');
                        input.classList.remove('validation--error');
                        input.setCustomValidity("");
                    };
                    input.addEventListener("invalid", setInvalidListener, false);

                    function setInvalidListener() {

                        if (!input.validity.valid) {

                            input.classList.add('validation--error');
                            const name = "js-" + input.getAttribute("name");
                            let message = "Það kom upp villa. Farðu yfir gögnin þín.";

                            if (event.target.getAttribute("validationmessage") && event.target.getAttribute("validationmessage").length > 1) {
                                message = input.getAttribute("validationmessage");
                            }
                            event.target.setCustomValidity(message);
                            input.removeEventListener("invalid", setInvalidListener, false);
                        }

                    }
                    if (!input.checkValidity()) {
                        if (buttonEvent) {
                            buttonEvent.stopImmediatePropagation();
                        }
                    }

                });
        }

    }
}

export default Validation;
